import BillingDetails from './components/BillingDetails';
import ClientDocuments from './components/ClientDocuments';
import CheckInDetailsSlider from './components/CheckInDetailsSlider';
import FoodLog from './components/FoodLog';
import ClientInfo, { AccordionId as ClientInfoAccordionId } from './components/ClientInfo';
import Notes from './components/Notes';
import WorkoutCalendar from './components/WorkoutCalendar';
import TrackAssignments from './components/TrackAssignments';
import WorkoutHistoryTabs from './components/WorkoutHistoryTabs';
import NutritionalHistory from './components/NutritionalHistory';
import RecipePreferences from './components/RecipePreferences';
import ClientSettings from './components/ClientSettings';
import ClientHistory from './components/ClientHistory';

import clientInfoTabs from './tabs';
import {
  StyledBillingIcon,
  StyledCheckinIcon,
  StyledForkIcon,
  StyledUserIcon,
  StyledNotesIcon,
  StyledSettings,
  StyledMealPlanIcon,
  StyledWorkoutHistoryIcon,
  StyledExerciseIcon,
  StyledHistoryIcon,
  StyledThumbsUpIcon,
  StyledTrackIcon,
  StyledDocumentsIcon,
} from './styles';
import texts from './texts.json';

const clientInfoTabsConfig = {
  [clientInfoTabs.CHECKIN_ACTIVITY]: {
    label: texts.tabLabels[clientInfoTabs.CHECKIN_ACTIVITY],
    icon: StyledCheckinIcon,
    component: CheckInDetailsSlider,
  },
  [clientInfoTabs.BILLING_DETAILS]: {
    label: texts.tabLabels[clientInfoTabs.BILLING_DETAILS],
    icon: StyledBillingIcon,
    component: BillingDetails,
  },
  [clientInfoTabs.FOOD_LOG]: {
    label: texts.tabLabels[clientInfoTabs.FOOD_LOG],
    icon: StyledForkIcon,
    component: FoodLog,
  },
  [clientInfoTabs.CLIENT_INFO]: {
    label: texts.tabLabels[clientInfoTabs.CLIENT_INFO],
    icon: StyledUserIcon,
    component: ClientInfo,
  },
};

const quickInfoTabsConfig = {
  [clientInfoTabs.NOTES]: {
    label: texts.tabLabels[clientInfoTabs.NOTES],
    icon: StyledNotesIcon,
    component: Notes,
  },
  [clientInfoTabs.WORKOUT_CALENDAR]: {
    label: texts.tabLabels[clientInfoTabs.WORKOUT_CALENDAR],
    icon: StyledExerciseIcon,
    component: WorkoutCalendar,
  },
  [clientInfoTabs.TRACK_ASSIGNMENTS]: {
    label: texts.tabLabels[clientInfoTabs.TRACK_ASSIGNMENTS],
    icon: StyledTrackIcon,
    component: TrackAssignments,
  },
  [clientInfoTabs.WORKOUT_HISTORY]: {
    label: texts.tabLabels[clientInfoTabs.WORKOUT_HISTORY],
    icon: StyledWorkoutHistoryIcon,
    component: WorkoutHistoryTabs,
  },
  [clientInfoTabs.NUTRITIONAL_HISTORY]: {
    label: texts.tabLabels[clientInfoTabs.NUTRITIONAL_HISTORY],
    icon: StyledMealPlanIcon,
    component: NutritionalHistory,
  },
  [clientInfoTabs.RECIPE_PREFERENCES]: {
    label: texts.tabLabels[clientInfoTabs.RECIPE_PREFERENCES],
    icon: StyledThumbsUpIcon,
    component: RecipePreferences,
  },
  [clientInfoTabs.CLIENT_SETTINGS]: {
    label: texts.tabLabels[clientInfoTabs.CLIENT_SETTINGS],
    icon: StyledSettings,
    component: ClientSettings,
  },
  [clientInfoTabs.CLIENT_HISTORY]: {
    label: texts.tabLabels[clientInfoTabs.CLIENT_HISTORY],
    icon: StyledHistoryIcon,
    component: ClientHistory,
  },
  [clientInfoTabs.CLIENT_INFO]: {
    label: texts.tabLabels[clientInfoTabs.CLIENT_INFO],
    icon: StyledUserIcon,
    component: ClientInfo,
    props: {
      defaultExpandedAccordion: ClientInfoAccordionId.POST_PAYMENT_ACCORDION,
    },
  },
  [clientInfoTabs.CLIENT_DOCUMENTS]: {
    label: texts.tabLabels[clientInfoTabs.CLIENT_DOCUMENTS],
    icon: StyledDocumentsIcon,
    component: ClientDocuments,
  },
};

export {
  clientInfoTabs,
  quickInfoTabsConfig,
  clientInfoTabsConfig,
};
